import { baseBackend } from "../../../api/base/baseUrl";
const URL_SCHEDULED = "/api/v1/module/scheduled";

export const createScheduled = async (scheduled) => {
  return await baseBackend.post(
    `${URL_SCHEDULED}/create`,
    JSON.stringify({ scheduled }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const readScheduled = async () => {
  return await baseBackend.get(`${URL_SCHEDULED}/read`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const readFinishScheduled = async () => {
  return await baseBackend.get(`${URL_SCHEDULED}/finish`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const readSubscribed = async () => {
  return await baseBackend.get(`${URL_SCHEDULED}/subscribed`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const readSubscribedById = async (id) => {
  return await baseBackend.get(`${URL_SCHEDULED}/booking/${id}`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const assignedScheduledDriver = async (scheduled) => {
  return await baseBackend.post(
    `${URL_SCHEDULED}/assign/driver`,
    JSON.stringify({ scheduled }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const rescheduleRepo = async (scheduled) => {
  return await baseBackend.post(
    `${URL_SCHEDULED}/reschedule`,
    JSON.stringify({ scheduled }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const linkPayScheduleRepo = async (scheduled) => {
  return await baseBackend.post(
    `${URL_SCHEDULED}/linkpay`,
    JSON.stringify({ scheduled }),
    { headers: { "Content-Type": "application/json" } }
  );
};

export const deleteScheduleRepo = async (scheduled) => {
  return await baseBackend.post(
    `${URL_SCHEDULED}/delete`,
    JSON.stringify({ scheduled }),
    { headers: { "Content-Type": "application/json" } }
  );
};
